var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a.625.625 0 0 1 .625.625v2.528a6.876 6.876 0 0 1 6.221 6.222h2.528a.625.625 0 0 1 0 1.25h-2.527a6.876 6.876 0 0 1-6.221 6.221v2.528a.625.625 0 0 1-1.25 0v-2.527a6.876 6.876 0 0 1-6.222-6.221H.625a.625.625 0 0 1 0-1.25h2.528a6.876 6.876 0 0 1 6.222-6.223V.625A.625.625 0 0 1 10 0zM6.023 6.023a5.625 5.625 0 1 0 7.955 0 5.625 5.625 0 0 0-7.955 0zM12.21 7.79a3.125 3.125 0 1 1-4.419 0 3.125 3.125 0 0 1 4.419 0zm-3.536.884a1.875 1.875 0 1 0 2.652 0 1.875 1.875 0 0 0-2.652 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.bf0895e8.svg";
export { ForwardRef as ReactComponent };